/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Audio_Recorder_Start_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to start recording: {error}" |
*
* @param {Audio_Recorder_Start_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_start_failed = /** @type {((inputs: Audio_Recorder_Start_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Start_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec du démarrage de l'enregistrement : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Aufzeichnung konnte nicht gestartet werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile avviare la registrazione: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось начать запись: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al iniciar la grabación: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`录制开始失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`録画を開始できませんでした: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`रिकॉर्डिंग शुरू करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao iniciar a gravação: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to start recording: ${i?.error}`)
});